import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import {
  setIsTableLoading,
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setTotalItems,
} from "src/redux/slices/TestCheckSlice";
import { RootState } from "src/redux/store";
import { useGetAllTestCheckWithPaginationQuery } from "src/services/TestCheckServices";
import TestCheckListing from "./TestCheckListing";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";

const TestCheckListingWrapper = () => {
  const dispatch = useDispatch();

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.testCheck);

  const { data, isLoading, isFetching } = useGetAllTestCheckWithPaginationQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: [
      "testTitle"
    ],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
      dispatch(setIsTableLoading(false));
    } else {
      dispatch(setIsTableLoading(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);



  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date",
      extraClasses: "min-w-[120x]",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <div>
          <div className="text-slate-700 font-medium text-base">
            {formatedDateTimeIntoIst(row.createdAt, "DD MMM yyyy")}
          </div>
        </div>
      ),
    },
    {
      field: "testTitle",
      headerName: "Test Title",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[120x]",
      renderCell: (row: any) => (
        <div className="capitalize"> {row?.testTitle} </div>
      ),
    },
    {
      field: "studentName",
      headerName: "Student Name",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[120x]",
      renderCell: (row: any) => (
        <div className="capitalize"> {row?.studentName} </div>
      ),
    },


  ];
  return (
    <div>
      <TestCheckListing
        rows={items}
        columns={columns}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />

    </div>
  );
};

export default TestCheckListingWrapper;
